import { useLocation, useNavigate, useSearchParams } from "react-router";
import { buildQueryString } from "utils/api/queryUtil";
import useViewMode from "./useViewMode";

const usePageNavigate = () => {
  const navigate = useNavigate(); // 네비게이션 훅
  const location = useLocation(); // 현재 경로 정보
  const [searchParams] = useSearchParams();
  const { isMobile } = useViewMode();

  /**
   * @desc 주어진 경로로 이동하는 함수
   * @param {string} path - 이동할 경로
   */
  const onNavClick = (path) => {
    if (path) navigate(path);
  };

  /**
   * @function onPrevBtnClick
   * @desc 이전 버튼 클릭 함수
   * @returns {void}
   */
  const onPrevClick = (e) => {
    navigate(-1);
  };

  /**
   * @desc 검색 파라미터를 포함하여 네비게이션하는 함수
   * @param {string} path - 이동할 경로
   */
  const onNavQueryClick = (path) => {
    const queryString = getQueryString(path);
    if (isMobile) {
      onNavClick(
        queryString
          ? `${path}?view=mobile&${queryString}`
          : `${path}?view=mobile`
      );
    } else {
      onNavClick(queryString ? `${path}?${queryString}` : path);
    }
  };

  /**
   * @desc 상세 페이지 링크를 생성하는 함수
   * @param {string} path - 이동할 경로
   * @returns {string} - 쿼리 문자열이 포함된 URL
   */
  const onLinkToDetail = (path) => {
    const queryString = getQueryString(path);
    if (isMobile) {
      return queryString
        ? `${path}?view=mobile&${queryString}`
        : `${path}?view=mobile`;
    } else {
      return queryString ? `${path}?${queryString}` : path;
    }
  };

  /**
   * @desc 현재 검색 파라미터를 기반으로 적절한 쿼리 문자열을 생성
   * @param {string} path - 경로
   * @returns {string} - 생성된 쿼리 문자열
   */
  const getQueryString = (path) => {
    const page = Number(searchParams.get("page")) || 1;
    const searchKeyword = searchParams.get("keyword") || "";
    const isNotice = path.includes("notice");
    const noticeType = searchParams.get("noticeType") || "전체";

    return buildQueryString({ size: 10, page: page, keyword: searchKeyword, noticeType: isNotice ? noticeType : undefined });
  };

  return {
    location,
    onPrevClick,
    onNavClick,
    onNavQueryClick,
    onLinkToDetail,
  };
};

export default usePageNavigate;
